const carouselItems = [
  {
    title: '2026暑期档观影指南',
    desc: '炎炎夏日，小草影院为你盘点今年暑期最值得期待的院线大片。从热血动作到爆笑喜剧，从科幻巨制到温馨动画，这份观影指南帮你轻松规划整个夏天的电影之旅，精彩不容错过。',
    tag: '暑期特辑',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20guide%20collage%20with%20warm%20golden%20sunlight%20and%20film%20poster%20fragments%2C%20amber%20and%20coral%20tones%2C%20vibrant%20composition%2C%20film%20strip%20border%20elements%2C%20cinematic%20atmosphere%2C%20energetic%20summer%20vibe&width=800&height=500&seq=carousel-summer-guide&orientation=landscape',
  },
  {
    title: '动作片黄金年代回顾',
    desc: '从上世纪香港功夫片到好莱坞硬汉时代，动作电影经历了辉煌的演变历程。小草影院精选每个时代的标志性动作大片，带你重温那些让人热血沸腾的经典瞬间与不朽传奇。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Classic%20action%20movie%20golden%20era%20collage%20with%20vintage%20film%20poster%20style%2C%20warm%20sepia%20and%20deep%20crimson%20tones%2C%20retro%20cinematic%20composition%2C%20film%20grain%20texture%2C%20nostalgic%20atmosphere&width=800&height=500&seq=carousel-action-era&orientation=landscape',
  },
  {
    title: '周星驰喜剧电影全盘点',
    desc: '从《大话西游》到《功夫》，小草影院为你完整盘点周星驰的经典喜剧作品。每一部都是华语喜剧电影的里程碑，无论重温多少次，依然能让你捧腹大笑、回味无穷。',
    tag: '喜剧专题',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20collage%20with%20playful%20golden%20and%20warm%20red%20tones%2C%20classic%20Hong%20Kong%20movie%20poster%20aesthetic%2C%20vibrant%20composition%2C%20film%20elements%2C%20joyful%20cinematic%20atmosphere&width=800&height=500&seq=carousel-chow-comedy&orientation=landscape',
  },
  {
    title: '科幻电影进化史',
    desc: '从早期黑白科幻到当代视觉奇观，科幻电影始终在突破想象的边界。小草影院梳理科幻电影的百年进化之路，推荐每个科幻迷都不容错过的里程碑作品。',
    tag: '深度解析',
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20film%20evolution%20collage%20with%20futuristic%20and%20vintage%20elements%2C%20deep%20space%20and%20warm%20bronze%20tones%2C%20cinematic%20composition%2C%20film%20poster%20fragments%2C%20epic%20atmosphere&width=800&height=500&seq=carousel-scifi-evolution&orientation=landscape',
  },
  {
    title: '高分爱情电影推荐',
    desc: '爱情是人类永恒的主题，优秀的爱情电影总能触动人心最柔软的地方。小草影院精选豆瓣和IMDB高分爱情电影，从经典老片到当代佳作，陪你感受爱的千百种模样。',
    tag: '情感推荐',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20film%20recommendation%20collage%20with%20soft%20warm%20lighting%20and%20gentle%20rose%20tones%2C%20dreamy%20bokeh%20effect%2C%20elegant%20cinematic%20composition%2C%20film%20poster%20aesthetic%2C%20tender%20atmosphere&width=800&height=500&seq=carousel-romance-top&orientation=landscape',
  },
  {
    title: '国产动画崛起之路',
    desc: '近年来国产动画电影迎来前所未有的繁荣期，《哪吒》《长安三万里》等现象级作品层出不穷。小草影院盘点国产动画的崛起历程，推荐值得一看的精品佳作。',
    tag: '国产精品',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20collage%20with%20vibrant%20traditional%20and%20modern%20elements%2C%20warm%20golden%20and%20crimson%20tones%2C%20artistic%20composition%2C%20ink%20wash%20aesthetic%20mixed%20with%20contemporary%20style%2C%20cinematic%20atmosphere&width=800&height=500&seq=carousel-china-anime&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            精选专题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            深度电影专题策划，带你发现更多值得一看的好片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden h-48">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
                <div className="mt-4 pt-4 border-t border-background-200/70">
                  <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-medium cursor-pointer whitespace-nowrap">
                    查看专题详情
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}